class colors {
  static getBackgroundColor = (value: number) => {
    if (!value || value < 5) return "var(--col-error-3)";
    else if (value >= 5 && value < 8) return "var(--col-warning-primary)";
    else return "var(--col-success-3)";
  };

  static getContinuityAndPreferenceScaleColor = (percent: number) => {
    if (percent < 50)
      return {
        borderColor: "var(--col-error-primary)",
        backgroundColor: "var(--col-error-2)",
      };
    else if (percent >= 50 && percent < 75)
      return {
        backgroundColor: "var(--col-warning-2)",
        borderColor: "var(--col-warning-primary)",
      };
    else if (percent >= 75)
      return {
        backgroundColor: "var(--col-success-1)",
        borderColor: "var(--col-success-3)",
      };
  };

  static getRulesScaleColor = (percent: number) => {
    if (percent < 80)
      return {
        borderColor: "var(--col-error-primary)",
        backgroundColor: "var(--col-error-2)",
      };
    else if (percent >= 80 && percent < 99)
      return {
        backgroundColor: "var(--col-warning-2)",
        borderColor: "var(--col-warning-primary)",
      };
    else if (percent >= 99)
      return {
        backgroundColor: "var(--col-success-1)",
        borderColor: "var(--col-success-3)",
      };
  };
}

export default colors;
